import { Flex, Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { NutritionInfo } from "../../../components/NutritionInfo.tsx";
import { formatNumber } from "../../../utils/nutritionFormat.ts";
import { genericIngredientDisplayName } from "../../../utils/genericIngredient.ts";
import { ComparePhotosButton } from "../ComparePhotosButton.tsx";
import { useIngredient } from "../IngredientContext.tsx";
import { clickable } from "../../../styles/shared.styles.ts";

export const IngredientNutritionTab = () => {
  const { t, i18n } = useTranslation();
  const { ingredient, units } = useIngredient();
  const gi = ingredient.genericIngredient;
  const showReference = ingredient.nutritionReferenceGrams !== 100;

  const referenceUnit = units.find((u) => u.id === ingredient.nutritionReferenceUnitId);
  const referenceTitle = t("ingredients.nutrition.perReference", {
    quantity: formatNumber(ingredient.nutritionReferenceQuantity, i18n.language),
    unit: referenceUnit?.code ?? "g",
  });

  return (
    <Flex gap="medium" vertical>
      <div>
        <ComparePhotosButton />
      </div>
      <Flex align="center" gap="small" wrap>
        {gi ? (
          <>
            {t("ingredients.nutrition.importedFrom", {
              name: genericIngredientDisplayName(gi, i18n.language),
            })}
            <Popover
              content={<NutritionInfo nutritionProfile={gi.nutritionProfile} />}
              destroyOnHidden
              title={genericIngredientDisplayName(gi, i18n.language)}
            >
              <InfoCircleOutlined className={clickable} />
            </Popover>
          </>
        ) : null}
      </Flex>
      <Flex gap="large" wrap>
        <NutritionInfo
          nutritionProfile={ingredient.nutritionProfile}
          title={t("ingredients.nutrition.perHundredGrams")}
        />
        {showReference ? (
          <NutritionInfo nutritionProfile={ingredient.referenceNutritionProfile} title={referenceTitle} />
        ) : null}
      </Flex>
    </Flex>
  );
};
